
// @ts-nocheck


export const localeCodes =  [
  "en",
  "it",
  "de",
  "es",
  "fr",
  "nl",
  "pt",
  "ru",
  "uk"
]

export const localeLoaders = {
  "en": [{ key: "../translations/en.js", load: () => import("../translations/en.js" /* webpackChunkName: "locale__app_translations_en_js" */), cache: true }],
  "it": [{ key: "../translations/it.js", load: () => import("../translations/it.js?hash=8f53ce8d&locale=it" /* webpackChunkName: "locale__app_translations_it_js" */), cache: false }],
  "de": [{ key: "../translations/de.js", load: () => import("../translations/de.js?hash=4c051e29&locale=de" /* webpackChunkName: "locale__app_translations_de_js" */), cache: false }],
  "es": [{ key: "../translations/es.js", load: () => import("../translations/es.js?hash=4079625d&locale=es" /* webpackChunkName: "locale__app_translations_es_js" */), cache: false }],
  "fr": [{ key: "../translations/fr.js", load: () => import("../translations/fr.js?hash=aac9c411&locale=fr" /* webpackChunkName: "locale__app_translations_fr_js" */), cache: false }],
  "nl": [{ key: "../translations/nl.js", load: () => import("../translations/nl.js?hash=aa4da730&locale=nl" /* webpackChunkName: "locale__app_translations_nl_js" */), cache: false }],
  "pt": [{ key: "../translations/pt.js", load: () => import("../translations/pt.js?hash=bfeecbf6&locale=pt" /* webpackChunkName: "locale__app_translations_pt_js" */), cache: false }],
  "ru": [{ key: "../translations/ru.js", load: () => import("../translations/ru.js?hash=6cd89583&locale=ru" /* webpackChunkName: "locale__app_translations_ru_js" */), cache: false }],
  "uk": [{ key: "../translations/uk.js", load: () => import("../translations/uk.js?hash=6243000f&locale=uk" /* webpackChunkName: "locale__app_translations_uk_js" */), cache: false }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en",
      "files": [
        "translations/en.js"
      ]
    },
    {
      "code": "it",
      "iso": "it",
      "files": [
        "translations/it.js"
      ]
    },
    {
      "code": "de",
      "iso": "de",
      "files": [
        "translations/de.js"
      ]
    },
    {
      "code": "es",
      "iso": "es",
      "files": [
        "translations/es.js"
      ]
    },
    {
      "code": "fr",
      "iso": "fr",
      "files": [
        "translations/fr.js"
      ]
    },
    {
      "code": "nl",
      "iso": "nl",
      "files": [
        "translations/nl.js"
      ]
    },
    {
      "code": "pt",
      "iso": "pt",
      "files": [
        "translations/pt.js"
      ]
    },
    {
      "code": "ru",
      "iso": "ru",
      "files": [
        "translations/ru.js"
      ]
    },
    {
      "code": "uk",
      "iso": "uk",
      "files": [
        "translations/uk.js"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "translations",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {
    "sitemap.xml": false
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "warnHtmlInMessage": "off",
  "strictMessage": false,
  "fallbackLocale": {
    "pr": [
      "pt"
    ],
    "default": [
      "en"
    ]
  },
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en",
    "files": [
      {
        "path": "translations/en.js"
      }
    ]
  },
  {
    "code": "it",
    "iso": "it",
    "files": [
      {
        "path": "translations/it.js"
      }
    ]
  },
  {
    "code": "de",
    "iso": "de",
    "files": [
      {
        "path": "translations/de.js"
      }
    ]
  },
  {
    "code": "es",
    "iso": "es",
    "files": [
      {
        "path": "translations/es.js"
      }
    ]
  },
  {
    "code": "fr",
    "iso": "fr",
    "files": [
      {
        "path": "translations/fr.js"
      }
    ]
  },
  {
    "code": "nl",
    "iso": "nl",
    "files": [
      {
        "path": "translations/nl.js"
      }
    ]
  },
  {
    "code": "pt",
    "iso": "pt",
    "files": [
      {
        "path": "translations/pt.js"
      }
    ]
  },
  {
    "code": "ru",
    "iso": "ru",
    "files": [
      {
        "path": "translations/ru.js"
      }
    ]
  },
  {
    "code": "uk",
    "iso": "uk",
    "files": [
      {
        "path": "translations/uk.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
